import { Box } from '@material-ui/core';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export const HorizontalScrollWrapper = (props) => {
  const { background } = useCustomTheme();
  return (
    <Box
      className={props.className ? props.className : 'fade-inline-wrapper'}
      style={{ '--background': background } as React.CSSProperties}
    >
      <Box className="fade-inline-scroll" style={{ overflowX: 'visible', overflowY: 'hidden' }}>
        <Box>{props.children}</Box>
      </Box>
    </Box>
  );
};
